<template lang="html">
	<entity-page id="page__manipulators-settings" v-loader-overlay="progress">
		<template slot="header-right">
			<z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
			<z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
		</template>
		
        <FlexTabs v-bind:tabs="tabs" v-model="activeTab" min />
        <ZModulePropertiesLogs v-if="activeTab === 'tab-logs'" v-bind:module="this.module" v-bind:properties="properties"></ZModulePropertiesLogs>

        <div v-if="form && activeTab === 'tab-settings'" class="page__manipulators-settings__settings row">
            <z-module-properties-input v-model="form" :properties="props.labels" ref="inputs-labels" />
            <div class="row">
                <z-module-properties-input v-model="form" :properties="props.display" ref="inputs-display" class="col-6" />
                <z-module-properties-input v-model="form" :properties="props.disable" ref="inputs-disable" class="col-6" />
            </div>
        </div>
	</entity-page>
</template>
<script>
    import FlexTabs from '@/components/FlexTabs';
	import ZInput   from '@/components/ZInput';
	import ZSelect  from '@/components/ZSelect';
	import EntityPage  from '@/components/EntityPage.vue';
	import ToggleCard  from '@/components/ToggleCard';
	import ZIconButton from '@/components/ZIconButton.vue';
	import ZInputAutocomplete     from '@/components/ZInputAutocomplete';
    import ZModulePropertiesLogs  from '@/components/ZModulePropertiesLogs';
    import ZModulePropertiesInput from '@/components/ZModulePropertiesInput'
	export default {
		components: {
            ZInput, ZSelect, ZInputAutocomplete, EntityPage,
            ToggleCard, ZIconButton, ZModulePropertiesLogs,
            FlexTabs, ZModulePropertiesInput
        },
		data() {
			return {
                module: 'cost',
                props: {
                    labels:  ['from_manipulator_label', 'to_manipulator_label'],
                    display: ['manipulator_forms_display'],
                    disable: ['manipulator_forms_disable']
                },
                form: {},
                activeTab: 'tab-settings',
                tabs: [
                    {name: "tab-settings", label: "Настройки"},
                    {name: "tab-logs",     label: "История"},
                ],
                refs: [
                    'inputs-labels'
                ]
            }
		},
		computed: {
            progressKey() {
                return 'load-manipulators-settings-card';
            },
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj[this.progressKey];
			},
			/**
			 * Объект с флагами загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
            properties() {
                const result = [];
                Object.values(this.props).map(item => result.push(...item));

                return result;
            }
		},
		methods: {
			/**
			 * Возвращение пользователя на предидущую страницу
			 */
			back() {
				this.$router.push({name: 'ManipulatorPrices', query: this.$route.query});
			},
			/**
			 * Инициализация компонента
			 */
			init() {
				this.$store.commit('openRightPanel');
                this.getValues();
			},
            getValues() {
                this.$store.commit('showProgressBar', this.progressKey);
                this.$store.dispatch('module/getModuleProperties', { module: this.module }).then(r => {
                    if (!r) return;
                    Object.entries(r)
                        .filter(([key]) => this.properties.includes(key))
                        .map(([key, value]) => {
                            if (!value.value && value.default_value) value.value = value.default_value;
                            this.$set(this.form, key, Object.assign(value))
                        });
                }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
            },
			/**
			 * Сохранение цены
			 */
			save() {
                if (this.progress) return;
                Promise.all(this.refs.map(key => this.$refs[key].validate())).then(valid => {
                    if (!valid.every(i => !!i)) return;
                    this.$store.commit('showProgressBar', this.progressKey);

                    const data = {module: this.module, values: []};

                    Object.entries(this.form)
                        .filter(([key]) => this.properties.includes(key))
                        .map(([key, value]) => data.values.push({
                            module_name: this.module,
                            prop_code:   key,
                            value:       value.value,
                            multiply:    value.multiply
                        }))

                    this.$store.dispatch('module/setModulePropertiesValue', data)
                        .then(() => this.init())
                        .finally(() => this.$store.commit('hideProgressBar', this.progressKey));
                });
			},         
		},
        created() {
			this.init();
		}
	}
</script>
<style lang="sass">
    #page__manipulators-settings
        .page__manipulators-settings__settings.row
            margin: 0
            .col-6
                margin: 0 5px 10px 5px
                width: calc(50% - 10px)
            
</style>


// WEBPACK FOOTER //
// ManipulatorsSettings.vue?66c6e659